import { Component, OnInit, Input, NgZone, OnDestroy, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Questionnaire, QuestionnaireState } from '../../../../../../backend/server/data-models/questionnaire/questionnaire.model';
import { QuestionnaireService } from '../../questionnaire/questionnaire.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { QuestionnaireTemplate } from '../../../../../../backend/server/data-models/questionnaire-template/questionnaire-template.model';
import { QuestionnaireTemplateSection, LikertAnswer, QuestionnaireSectionType } from '../../../../../../backend/server/data-models/questionnaire-template/questionnaire-template-section.model';
import { QuestionnaireTemplateQuestion, QuestionnaireTemplateAnswer, QuestionType } from '../../../../../../backend/server/data-models/questionnaire-template/questionnaire-template-question.model';
import { QuestionnaireSchedule } from '../../../../../../backend/server/data-models/questionnaire/questionnaire-schedule.model';
import { QuestionnaireTemplateService } from '../../questionnaire-template/questionnaire-template.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { QuestionnaireScheduleComponent } from '../../questionnaire/questionnaire-schedule/questionnaire-schedule.component';
import { LocalDateTime } from '../../../../../../backend/server/data-models/local-date-time/local-date-time';
import { ThrowStmt } from '@angular/compiler';
import { QuestionnaireResultAnswer } from '../../../../../../backend/server/data-models/questionnaire-result/questionnaire-result-answer.model';
import { QuestionnaireResultSection } from '../../../../../../backend/server/data-models/questionnaire-result/questionnaire-result-section.model';
import { QuestionnaireResult, QuestionnaireResultState, QuestionnaireResultSuspend } from '../../../../../../backend/server/data-models/questionnaire-result/questionnaire-result.model';
import { QuestionnaireResultService } from '../../questionnaire-result/questionnaire-result.service';
import { isDateValid } from 'ngx-bootstrap';


const SweetAlert = require('sweetalert');

@Component({
  selector: 'app-questionnaire-fill',
  templateUrl: './questionnaire-fill.component.html',
  styleUrls: ['./questionnaire-fill.component.scss']
})
export class QuestionnaireFillComponent implements OnInit, OnDestroy {

  private routeSubscription: Subscription;

  private id: string = null;
  private seq: number = null;

  questionnaire: Questionnaire;
  result: QuestionnaireResult;
  template: QuestionnaireTemplate;
  sections: QuestionnaireTemplateSection[];
  templateForm: FormGroup;
  answerForm: FormGroup;

  // Ez kell, hogy a felületre async módon kikerüljön
  //@Input() questionnaire: Promise<Questionnaire>;
  //questionnaireSubject: BehaviorSubject<Questionnaire> = new BehaviorSubject<Questionnaire>(new Questionnaire());
  //templates: QuestionnaireTemplate[];
  //modalRef: BsModalRef | null;
  //viewTemplateID: Promise<QuestionnaireTemplate>


  constructor(
    private ngZone: NgZone,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private translateService: TranslateService,
    //private modalService: BsModalService,
    private templateService: QuestionnaireTemplateService,
    private questionnaireService: QuestionnaireService,
    private resultService: QuestionnaireResultService
  ) {
    // translateService.use(translateService.getBrowserLang());
  }

  get getFormSections() {
    return this.answerForm.controls["sections"] as FormArray;
  }

  ngOnInit() {
    this.routeSubscription = this.route.params.subscribe(params => {
      //console.warn("questionnaire ID: " + params["id"]);
      const id = params['id'];
      if (id) {
        //console.warn("questionnaire ID2: " + id);
        this.questionnaireService.get(id).then( q => {
          this.questionnaire = q;
          this.id = q.id;
          this.seq = q.seq;

          this.template = q.template;
          this.sections = q.template.sections;

          this.answerForm = this.formBuilder.group({
            questionnaireId : [this.id],
            userId: [Meteor.userId()],
            scheduleOrder : [0],
            scheduledAt: [q.activeFrom],
            scheduledUntil: [q.activeTo],
            state: [0],
            startedAt: [new LocalDateTime()],
            finishedAt: [new LocalDateTime()],
            sections: this.formBuilder.array([]),
            suspends: this.formBuilder.array([]),
            processedAt: [new LocalDateTime()]
          });

          for(let i = 0; i < this.sections.length; i++){
            const sectionForm = this.formBuilder.group({
              order: [this.sections[i].order],
              type: [this.sections[i].type],
              answers: this.formBuilder.array([]),
              startedAt: [new LocalDateTime()],
              finishedAt: [new LocalDateTime()]
            });

            for(let j = 0; j < this.sections[i].questions.length; j++){
              let question = this.sections[i].questions[j];
              
              let questionForm;
              
              if(question.type != 2){
                questionForm = this.formBuilder.group({
                  questionOrder: [question.order],
                  value: ["", Validators.required],
                  startedAt: [new LocalDateTime()],
                  finishedAt: [new LocalDateTime()]
                });
              }else{
                questionForm = this.formBuilder.group({
                  questionOrder: [question.order],
                  value: this.formBuilder.array([]),
                  startedAt: [new LocalDateTime()],
                  finishedAt: [new LocalDateTime()]
                });

                for(let k = 0; k < this.sections[i].questions[j].answers.length; k++){
                  let answer = this.sections[i].questions[j].answers[k];
                  const answerFormInside = this.formBuilder.group({
                    optionText: [answer.text],
                    checked: [false]
                  });
                  (questionForm.controls["value"] as FormArray).push(answerFormInside);
                }
              }
              (sectionForm.controls["answers"] as FormArray).push(questionForm);
            }

            (this.answerForm.controls["sections"] as FormArray).push(sectionForm);
          }
        });
      }
      else {
        console.warn("QUESTIONNAIRE ID NULL");
      }
    });   
  }
  
  initSection(): FormGroup {
    return new FormGroup({
      sectionTitle: new FormControl(''),
      sectionDescription: new FormControl(''),
      questions: new FormArray([
        this.initQuestion()
        ])
    });
  }

  initQuestion(): FormGroup{
    return new FormGroup({
      questionTitle: new FormControl(''),
      questionType: new FormControl('',Validators.required),
      options: new FormArray([
        this.initOptions()
      ])
    });
  }

  initOptions(): FormGroup {
    return new FormGroup({
      optionTitle: new FormControl('')
    });
  }

  ngOnDestroy(): void {
    if (this.routeSubscription) this.routeSubscription.unsubscribe();
  }

  getId(): string {
    return this.id;
  }


  async validateQuestionnaireAnswers(answer: QuestionnaireResult): Promise<boolean>{
    let isValid : boolean = true;
    let questionnaireId = this.answerForm.get('questionnaireId').value;
    await this.questionnaireService.get(questionnaireId).then(q => {
      let questionnaire: Questionnaire = q;
      isValid = (
        questionnaire.state === 1 
        && questionnaire.activeFrom.isBefore( new LocalDateTime() ) 
        && (questionnaire.activeTo == null || questionnaire.activeTo.isAfter( new LocalDateTime() ) )
      );
    });
    return isValid;
  }

  getQuestionnaireDataFromForm(): QuestionnaireResult{
    let answer  = new QuestionnaireResult();
    let form = this.answerForm;
      
    answer.questionnaireId = form.get('questionnaireId').value;
    answer.userId = form.get('userId').value;

    answer.scheduleOrder = form.get('scheduleOrder').value;
    answer.scheduledAt = form.get('scheduledAt').value;
    //answer.scheduledAt = r.scheduledAt;
    answer.scheduledUntil = form.get('scheduledUntil').value;
    //answer.scheduledUntil = r.scheduledUntil;

    //answer.state = QuestionnaireResultState.Finished;
    answer.state = form.get('state').value;

    let sectionsArray = form.get('sections') as FormArray;
    let QuestionnaireResultSectionArray: QuestionnaireResultSection[] = [];
 

    for(let i = 0; i < sectionsArray.controls.length; i++){
      let currentSection: QuestionnaireResultSection = new QuestionnaireResultSection;
      currentSection.order = sectionsArray.controls[i].get('order').value;
      currentSection.type = sectionsArray.controls[i].get('type').value;
      currentSection.startedAt = sectionsArray.controls[i].get('startedAt').value;

      let answersArray = sectionsArray.controls[i].get('answers') as FormArray;
      let QuestionnaireResultAnswerArray: QuestionnaireResultAnswer[] = [];
      for(let j = 0; j < answersArray.controls.length; j++){
        let currentAnswer: QuestionnaireResultAnswer = new QuestionnaireResultAnswer;
        currentAnswer.questionOrder = answersArray.controls[j].get('questionOrder').value;
        currentAnswer.startedAt = answersArray.controls[j].get('startedAt').value;
        currentAnswer.finishedAt = new LocalDateTime();

        switch(this.sections[i].questions[j].type){
          case 0: //szöveges
          {
            currentAnswer.value = answersArray.controls[j].get('value').value;
            break;
          }
          case 1: //oneselect
          {
            currentAnswer.value = +answersArray.controls[j].get('value').value;
            break;
          }
          case 2: //multiselect
          {
            let selectedValues: number[] = [];
            let values = (answersArray.controls[j].get('value') as FormArray);
            for(let k : number = 0; k < values.length; k++){
              if(values.controls[k].get('checked').value){
                selectedValues.push(k+1);
              }
            }
            currentAnswer.value = selectedValues;
            break;
          }
          case 3: //likertscale
          {
            currentAnswer.value = +answersArray.controls[j].get('value').value;
            break;
          }
          case 4: //likert
          {
            currentAnswer.value = +answersArray.controls[j].get('value').value;
            break;
          }
          default:
          {
            break;
          }
        }

        QuestionnaireResultAnswerArray.push(currentAnswer);
      }
      currentSection.answers = QuestionnaireResultAnswerArray;
      currentSection.finishedAt = new LocalDateTime(); //sectionsArray.controls[i].get('finishedAt').value;

      QuestionnaireResultSectionArray.push(currentSection);
    }
    answer.sections = QuestionnaireResultSectionArray; //QuestionnaireResultAnswer

    //TODO: suspends, ez még nem működő funkció
    let suspendsArray = form.get('suspends') as FormArray;
    answer.suspends = [];

    answer.startedAt = form.get('startedAt').value;
    answer.finishedAt = new LocalDateTime();

    answer.processedAt = null;


    return answer;
  }

  private showMessage(title: string, text: string, type: string = "warning") {
    return SweetAlert({
      title: title,
      text: text,
      icon: type,
      buttons: {
        confirm: {
          text: this.translateService.instant('collectables.BUTTON_OK'),
          value: true,
          visible: true,
          className: "btn-primary",
          closeModal: true,
        }
      },
      closeOnClickOutside: false,
      allowOutsideClick: false
    });
  }

  onSubmit() {
    if(this.answerForm.valid){
      let answer = this.getQuestionnaireDataFromForm();
      //let isValid = 
      //if(isValid){ 
      this.validateQuestionnaireAnswers(answer).then(v => {
        if(v){
          this.resultService.create(this.id, 0).then(r => {
            this.resultService.update(r._id.toHexString(), r.seq, answer).then(r => {
              this.resultService.finish(r._id.toHexString(), r.seq, answer).then(r => {
                this.showMessage(
                  this.translateService.instant("questionnaire-result.SUCCESS"),
                  this.translateService.instant("questionnaire-result.FILL_IN_SUCCESSFUL")
                ).then(value => {
                  if (value) {
                    this.ngZone.run(() => this.router.navigate(['/questionnaire/list']));
                  }
                })
              });
            });
          });
        }else{
          this.showMessage(
            this.translateService.instant("questionnaire-result.ERROR"), 
            this.translateService.instant("questionnaire-result.QUESTIONNAIRE_NOT_IN_ACTIVE_TIME_RANGE")
          );
        }
      });
    }else{
      this.showMessage(
        this.translateService.instant("questionnaire-result.ERROR"), 
        this.translateService.instant("questionnaire-result.FILL_IN_EVERY_REQUIRED")
      );
    }
  }

  save(): void {

    //let result = this.getQuestionnaireDataFromForm()

    this.ngZone.run(() => this.router.navigate(['/questionnaire/list']));
  }

}
